module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32.63 32.63\"><path d=\"M32.13 16.82H.5c-.28 0-.5-.23-.5-.5s.22-.5.5-.5h31.64c.27 0 .5.22.5.5s-.23.5-.5.5z\"/><path d=\"M13.04 29.35c-.13 0-.26-.05-.36-.14L.15 16.68c-.1-.1-.15-.22-.15-.36s.05-.24.15-.34L12.68 3.43c.2-.2.52-.2.7 0s.2.5 0 .7L1.22 16.34l12.2 12.17c.2.2.2.5 0 .7-.1.1-.24.15-.36.15z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-left.svg
// module id = ./src/icons/arrow-left.svg
// module chunks = 21